<div class="d-flex flex-column full-page-height">
  <main class="flex-grow-1">
    <router-outlet></router-outlet>
  </main>
  <app-footer/>
  <app-modal/>
</div>
